import { Routes, Route } from 'react-router-dom';
import { SharePage } from './pages/SharePage';
import { NotFound } from './pages/NotFound';

/**
 * 根组件：定义应用路由
 *
 * 路由规则：
 * - /s/:token  分享页面，通过 token 加载分享内容
 * - /*         其他路径显示 404 页面
 */
export function App(): React.JSX.Element {
  return (
    <Routes>
      <Route path="/s/:token" element={<SharePage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
